module.exports = require('./voting-list');
